import React from "react";
import './Management.css'
import useMeta from '../../../hooks/useMeta';

import Navbar from "../../../CommonComponent/Navbar/Navbar";
import NotificationBar from "../../../CommonComponent/Notification/NotificationBar";
import Footer from "../../../CommonComponent/Footer/footer";


const Management = () => {

    useMeta({
        title: 'Board of Directors | Marvel Blinds',
        description: 'Chairman and Managing Director Mr Ashok R. Paun aged 51 years is the Chairman and Managing Director of the Company looks into the core matters of the Company. Shri Ashok R. Paun is the promoter of the Company and has 29 years of experience for Industrial management, planning, manpower skill development planning and adopting new […]',
        canonical: `${process.env.REACT_APP_WEBSITE_URL}/management`,
        og: {
            locale: 'en_US',
            type: 'article',
            title: 'Board of Directors',
            description:
                'Chairman and Managing Director Mr Ashok R. Paun aged 51 years is the Chairman and Managing Director of the Company looks into the core matters of the Company. Shri Ashok R. Paun is the promoter of the Company and has 29 years of experience for Industrial management, planning, manpower skill development planning and adopting new […]',
            url: `${process.env.REACT_APP_WEBSITE_URL}/management`,
            site_name: 'Marvel Blinds',
        },
    });

    return (
        <>
            <Navbar />
            <NotificationBar />
            <div className="Management-pg-container">
                <h2 className="fact-sheet-title">Board of Directors</h2>
                <table className="Management-pg-content-table">
                    <tbody>
                        <tr>
                            <th className="even-row">Chairman and Managing Director	</th>
                            <td className="even-row">
                                <b>Mr Ashok R. Paun</b> aged 51 years is the Chairman and Managing Director of the Company looks into the core matters of the Company. Shri Ashok R. Paun is the promoter of the Company and has 29 years of experience for Industrial management, planning, manpower skill development planning and adopting new technology he has been undertaking activities for Nation acceptance to be Digital India. He is being thoroughly overlooking business ongoing and insights on a regular basis. His contribution to the research and development aspect to bring in innovations in our products has been significant.
                            </td>
                        </tr>
                        <tr>
                            <th>Whole Time Director	</th>
                            <td>
                                <b>Mr Dipak R. Paun</b> aged 56 years, is the Promoter and Whole Time Director of the Company looks after pre-dispatch activities of the Company, like planning of material procurement, production and streaming of dispatch of finish goods. He has his involvement in Finance, fund flows with respect to the collection as well as payment. He has also a vital role in the implementation of Rules, Regulation & Policy made, which has played a major role in the operation and success of the Company. He undertakes the comprehensive ongoing of both the factories.
                            </td>
                        </tr>
                        <tr>
                            <th className="even-row">Executive Director and CFO	</th>
                            <td className="even-row"><b>Mrs Urmi A. Paun</b> aged 51 years is the Executive Director and Cheif Financial Officer of the Company looking in to complete matters of Finance & Purchase segment of the Company. She serves a noteworthy and major part in the Research & Development and Procurement division. She also looks after the banking activities. Her presence has been significant towards the journey of the Company.
                            </td>
                        </tr>
                        <tr>
                            <th>Non Executive Director	</th>
                            <td><b>Mrs Dipti D. Paun</b> aged 49 years is the Non – Executive Director of the Company. She has significant experience in the field of administration. She is Director of the company since 2010.
                            </td>
                        </tr>
                        <tr>
                            <th className="even-row">Non Executive Director</th>
                            <td className="even-row"><b>Miss Khwahish A. Paun</b> aged 22 years is the Non – Executive Director of the Company. She has done her Graduation from HR College Mumbai and join the business from two and half years. She got training at Jamnagar Unit in Marvel Decor Limited and looking for International business of Company.
                            </td>
                        </tr>
                        <tr>
                            <th>Non Executive & Independent Director</th>
                            <td><b>Mr Dhansukhbhai J. Devani</b> aged 51 years is a Non- Executive Independent Director of the Company. Having a Bachelor’s Degree in Civil Engineering, he has a vast experience of 26 Years in managing companies which is engaged in Civil Construction. He is also the Director of M/s. Shanti Construction (Guj) Pvt. Ltd., Jamnagar (Gujarat) which is into civil construction of Commercial & Residential Building and Government contracts.
                            </td>
                        </tr>
                        <tr>
                            <th className="even-row">Non Executive & Independent Director</th>
                            <td className="even-row">
                                <b>Mr Rajesh J. Morzaria</b> aged 54 years is a Non- Executive Independent Director of the Company. He is a partner in the firm named GOLDEN ENGINEERING Co. which is engaged into manufacturing of bearing cage and supplying bearing cage to the leading bearing manufacturers. He has experience of more than 3 decades in engineering and manufacturing.
                            </td>
                        </tr>
                        <tr>
                            <th>Non Executive & Independent Director</th>
                            <td>
                                <b>Mr Dhiren M. Shah</b> aged 42 years is a Non- Executive Independent Director of the Company. He is also Director of Quba Architecure Products Pvt. Ltd. and having a vast experience of more than 20 years in Interior Products.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <Footer />
        </>
    );
}

export default Management;